import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=8f830748&scoped=true&"
import script from "./setPassword.vue?vue&type=script&lang=js&"
export * from "./setPassword.vue?vue&type=script&lang=js&"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=8f830748&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f830748",
  null
  
)

export default component.exports